/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useStyles } from "../styles";

const SingleVerticalLine = () => {
  const { boxWithRightBorder, boxWithoutBorders } = useStyles();

  return (
    <>
      <div css={{ display: "flex", width: "100%" }}>
        <div css={css(boxWithRightBorder)}></div>
        <div css={css(boxWithoutBorders)}></div>
      </div>
      <div css={{ display: "flex", width: "100%" }}>
        <div css={css(boxWithRightBorder)}></div>
        <div css={css(boxWithoutBorders)}></div>
      </div>
    </>
  );
};
export default SingleVerticalLine;
